import { render, staticRenderFns } from "./ImageTemplate.vue?vue&type=template&id=7f3cdab2&scoped=true&"
import script from "./ImageTemplate.vue?vue&type=script&lang=js&"
export * from "./ImageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3cdab2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f3cdab2')) {
      api.createRecord('7f3cdab2', component.options)
    } else {
      api.reload('7f3cdab2', component.options)
    }
    module.hot.accept("./ImageTemplate.vue?vue&type=template&id=7f3cdab2&scoped=true&", function () {
      api.rerender('7f3cdab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/ImageTemplate.vue"
export default component.exports